// extracted by mini-css-extract-plugin
export default {"pokeContainer":"EachPoke_pokeContainer__Ha8KB","pokeImg":"EachPoke_pokeImg__ZM1JF","details":"EachPoke_details__3QmWz","pokeNumber":"EachPoke_pokeNumber__9dxAp"};